import type { GatePassApiResponseItem, GatePassListItem } from "@services/gatepass/types";

export const mapGatePasses = (data: GatePassApiResponseItem[]): GatePassListItem[] =>
  data.map(
    (item): GatePassListItem => ({
      id: item.id,
      gatepassId: String(item.serialNumber ?? ""),
      gatePassNo: String(item.gatepassSequence ?? ""),
      groupNo: String(item.gatepassSequenceGroup ?? ""),
      gatepassCategory: item.gatepassCategory ?? "",
      truckType: item.truckDetails?.truckType ?? null,
      requestType: item.gatepassType ?? "",
      sponsorCompany: item.sponsorCompany ?? "",
      passportNumber: item.visitor?.passportNumber ?? "N/A",
      emiratesIdNumber: item.visitor?.emiratesIdNumber ?? "N/A",
      companyName: item.companyName ?? "",
      individualName: item.visitor?.fullNameEnglish ?? "",
      hazard:
        item.truckDetails?.hazard === null || item.truckDetails?.hazard === undefined
          ? ""
          : item.truckDetails?.hazard
            ? "Yes"
            : "No",
      serviceNo: item.truckDetails?.serviceNumber ?? "",
      jobNo: item.truckDetails?.jobNumber ?? "",
      submittedAt: item.submittedAt ?? "",
      status: item.status,
      task: item.task ?? null,
      claimedByPreferredUsername: item.claimedByPreferredUsername ?? null,
    }),
  );
